import { useAppStore } from '@store'
import { Walls } from '@types'

export default function AngleHandler({ id }: { id: string }) {
  const item = useAppStore.use.items().get(id)! as Walls
  const prevWall = item.prevWall!
  const width = item.width
  const thickness = item.thickness
  const prevWallRotation = useAppStore((store) => store.items.get(prevWall)?.rotation!)
  const rotation = useAppStore.use.items().get(id)?.rotation!
  const innerAngle = useAppStore((store) => store.items.get(id)?.innerAngle)
  const theta = rotation - (prevWallRotation ? prevWallRotation : 0)

  return (
    <mesh
      key={`angle-handler-${width}:${id}-${innerAngle}-${rotation}-${thickness}-${prevWallRotation}-`}
      position={[-width / 2, 2, thickness / 2]}
      rotation={[-Math.PI / 2, 0, 0]}
    >
      <circleGeometry args={[200, 34, theta + Math.PI, innerAngle]} />
      <meshBasicMaterial
        color='white'
        toneMapped={false}
      />
      <mesh position={[0, 0, -1]}>
        <circleGeometry args={[205, 34, theta + Math.PI, innerAngle]} />
        <meshBasicMaterial
          color='#6386A1'
          toneMapped={false}
        />
      </mesh>
    </mesh>
  )
}
